import { createFileRoute } from '@tanstack/react-router';
import { VehiclesClient } from '@/features/fuel/VehiclesClient';

export const Route = createFileRoute('/_shell/fuel/vehicles/')({
  component: VehiclesClient,
});
